import { motion } from 'motion/react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Linkedin, Facebook, Mail, Phone, MapPin } from 'lucide-react';
import { useEffect } from 'react';

const logoImage = new URL("../assets/logos/fat-logo.webp", import.meta.url).href;

const scrollToSection = (hash: string, delay = 0) => {
  const run = () => {
    const target = document.querySelector(hash);
    if (target) {
      const offset = 96;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };
  delay > 0 ? setTimeout(run, delay) : run();
};

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const practiceAreas = [
    { label: 'Commercial Litigation', to: '/commercial-litigation' },
    { label: 'Debt Recovery', to: '/debt-recovery' },
    { label: 'Mediation', to: '/mediation' },
    { label: 'Arbitration', to: '/arbitration' },
    { label: 'Contract Drafting & Support', to: '/contract-drafting-&-support' },
    { label: 'Corporate Governance Services', to: '/corporate-governance-services' },
    { label: 'Trademark Registration', to: '/trademark-registration' },
  ];

  const quickLinks = [
    { label: 'Who We Are', to: '/top-Law-firm-in-KSA' },
    { label: 'Values', to: '/our-value' },
    { label: 'Our Team', to: '/tamimi-lawfirm-team' },
      { label: 'Areas Of Practice', to: '/areas-of-practice' },
    { label: 'Accreditations', to: '/accreditations' },
    { label: 'Vision 2030', to: '/vision-2030' },
    { label: 'Invest in Saudi Arabia', to: '/invest-in-saudi-arabia' },
  ];

  const legalLinks = [
     { label: 'Our Associates', to: '/our-associates' },
      { label: 'Insights', to: '/blog' },
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Terms of Service', to: '/terms-of-service' },
    { label: 'Disclaimer', to: '/disclaimer' },
    { label: 'FAQs', to: '/faqs' },
  ];

  const handleSmoothScroll = (hash: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (isHomePage) {
      scrollToSection(hash);
    } else {
      navigate('/');
      scrollToSection(hash, 500);
    }
  };

  const handleNavigation = (to: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    navigate(to);
  };

  return (
    <footer className="bg-[#0a0a0a] text-white relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c3a565]/40 to-transparent" />
      <div className="absolute top-10 right-10 w-64 h-64 rounded-full bg-[#c3a565]/5 blur-3xl" />
      <div className="absolute bottom-10 left-10 w-48 h-48 rounded-full bg-[#c3a565]/5 blur-3xl" />

      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 relative z-10">
         <div className='contact-sm mb-6'>
            <motion.div
              className="mb-6"
              // initial={{ opacity: 0, y: 20 }}
              // whileInView={{ opacity: 1, y: 0 }}
              // viewport={{ once: true }}
              // transition={{ duration: 0.6 }}
            >
              <Link 
                to="/" 
                onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
              >
               {/* <img
              src={logoImage}
              alt="logo"
              width={180}
              height={60}
              className="logo"
            /> */}
            <img
  src={logoImage}
  alt="Fahad Al Tamimi Law Firm"
  width="240"
  height="60"
  fetchPriority="high"
  className="h-10 sm:h-12 lg:h-14 w-auto logo"
/>
              </Link>
            </motion.div>

            <p className="text-white/60 leading-relaxed mb-6 text-sm">
              Your trusted legal partner for corporate matters, regulatory compliance, and strategic
              market entry across Saudi Arabia and the GCC region.
            </p>

            <div className="flex gap-3">
              {[
                { icon: Linkedin, href: 'https://www.linkedin.com/company/tamimilawfirm/', label: 'LinkedIn' },
                { icon: Facebook, href: 'https://www.facebook.com/FahadAlTamimiLawfirm', label: 'Facebook' },
              ].map((social, i) => {
                const Icon = social.icon;
                return (
                  <motion.a
                    key={i}
                    href={social.href}
                    aria-label={social.label}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:bg-[#c3a565] hover:text-[#2b2b2a] hover:border-[#c3a565] transition-all duration-300"
                    whileHover={{ scale: 1.1, y: -3 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Icon className="w-4 h-4" />
                  </motion.a>
                );
              })}
            </div>
          </div>


        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12 mb-12">
          {/* desktop */}
          <div className='contact-md'>
            <motion.div
              className="mb-6"
              // initial={{ opacity: 0, y: 20 }}
              // whileInView={{ opacity: 1, y: 0 }}
              // viewport={{ once: true }}
              // transition={{ duration: 0.6 }}
            >
              <Link 
                to="/" 
                onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
              >
               <img
  src={logoImage}
  alt="Fahad Al Tamimi Law Firm"
  width="240"
  height="60"
  fetchPriority="high"
  className="h-10 sm:h-12 lg:h-14 w-auto logo"
/>
              </Link>
            </motion.div>

            <p className="text-white/60 leading-relaxed mb-6 text-sm">
              Your trusted legal partner for corporate matters, regulatory compliance, and strategic
              market entry across Saudi Arabia and the GCC region.
            </p>

            <div className="flex gap-3">
              {[
                { icon: Linkedin, href: 'https://www.linkedin.com/company/tamimilawfirm/', label: 'LinkedIn' },
                { icon: Facebook, href: 'https://www.facebook.com/FahadAlTamimiLawfirm', label: 'Facebook' },
              ].map((social, i) => {
                const Icon = social.icon;
                return (
                  <motion.a
                    key={i}
                    href={social.href}
                    aria-label={social.label}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:bg-[#c3a565] hover:text-[#2b2b2a] hover:border-[#c3a565] transition-all duration-300"
                    whileHover={{ scale: 1.1, y: -3 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Icon className="w-4 h-4" />
                  </motion.a>
                );
              })}
            </div>
          </div>

          {/* Services Section */}
          <div>
            <span className="mb-5 text-sm uppercase tracking-wider text-[#c3a565] font-bold">
              Services
            </span>
            <ul className="space-y-3 mt-2">
              {practiceAreas.map((area) => (
                <li key={area.label}>
                  <motion.div
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                  >
                    <Link
                      to={area.to}
                      onClick={handleNavigation(area.to)}
                      className="text-white/60 hover:text-[#c3a565] transition-colors inline-flex items-center gap-2 group text-sm cursor-pointer"
                    >
                      {/* <span className="w-1 h-1 rounded-full bg-[#c3a565] opacity-0 group-hover:opacity-100 transition-opacity" /> */}
                      {area.label}
                    </Link>
                  </motion.div>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <span className="mb-5 text-sm uppercase tracking-wider text-[#c3a565] font-bold">
              About Us
            </span>
            <ul className="space-y-3 mt-2">
              {quickLinks.map((link) => (
                <li key={link.label}>
                    <motion.div
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                  >
                  <Link
                    to={link.to}
                      onClick={handleNavigation(link.to)}
                      className="text-white/60 hover:text-[#c3a565] transition-colors inline-flex items-center gap-2 group text-sm cursor-pointer"
                    >
                    {/* <span className="w-1 h-1 rounded-full bg-[#c3a565] opacity-0 group-hover:opacity-100 transition-opacity" /> */}
                    {link.label}
                  </Link>
                  </motion.div>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-1">
            <span className="mb-5 text-sm uppercase tracking-wider text-[#c3a565] font-bold">
              Useful Links
            </span>
            <ul className="space-y-3 mt-2">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <motion.div
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                  >
                    <Link
                      to={link.to}
                      onClick={handleNavigation(link.to)}
                      className="text-white/60 hover:text-[#c3a565] transition-colors inline-flex items-center gap-2 group text-sm cursor-pointer"
                    >
                      {/* <span className="w-1 h-1 rounded-full bg-[#c3a565] opacity-0 group-hover:opacity-100 transition-opacity" /> */}
                      {link.label}
                    </Link>
                  </motion.div>
                </li>
              ))}
            </ul>
          </div>
          {/* desktop */}
          <div className='contact-md'>
            <span className="mb-5 text-sm uppercase tracking-wider text-[#c3a565] font-bold">
              Get in Touch
            </span>
            <div className="space-y-4 mt-2">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#c3a565] mt-1 flex-shrink-0" />
                <div className="text-white/60 text-sm">
                  Al Ashriah Street, Al Shatea 10th Floor, Ash Shati Ash Sharqi, Dammam 32414
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#c3a565] mt-1 flex-shrink-0" />
                <a href="mailto:info@tamimilawfirm.com" className="text-white/60 hover:text-[#c3a565] transition-colors text-sm mail-word-wrap">
                  info@tamimilawfirm.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#c3a565] mt-1 flex-shrink-0" />
                <a href="tel:+966138223832" className="text-white/60 hover:text-[#c3a565] transition-colors text-sm">
                  +966 13 822 3832
                </a>
              </div>
            </div>
          </div>
        </div>

{/* belwo sm */}
       <div className='mb-5 contact-sm'>
            <span className="mb-5 text-sm uppercase tracking-wider text-[#c3a565] font-bold">
              Get in Touch
            </span>
            <div className="space-y-4 mt-2">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#c3a565] mt-1 flex-shrink-0" />
                <div className="text-white/60 text-sm">
                  Al Ashriah Street, Al Shatea 10th Floor, Ash Shati Ash Sharqi, Dammam 32414
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#c3a565] mt-1 flex-shrink-0" />
                <a href="mailto:info@tamimilawfirm.com" className="text-white/60 hover:text-[#c3a565] transition-colors text-sm mail-word-wrap">
                  info@tamimilawfirm.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#c3a565] mt-1 flex-shrink-0" />
                <a href="tel:+966138223832" className="text-white/60 hover:text-[#c3a565] transition-colors text-sm">
                  +966 13 822 3832
                </a>
              </div>
            </div>
          </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-center items-center gap-4 copyright-sec">
          <p className="text-white/40 text-xs text-center sm:text-left">
            © {new Date().getFullYear()}{' '}
            <span style={{ color: '#c3a565' }}>
              <Link 
                to="/" 
                onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
              >
                Fahad Al Tamimi Law Firm.
              </Link>
            </span>{' '}
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};